module.exports = __webpack_public_path__ + "assets/img/profile-empty-150.05478cd4.png";